<boi-form-outgoings  [mortgageApplication]="mortgageApplication" [isLoanGroupTypeBtlAffordability]="isLoanGroupTypeBtlAffordability()"></boi-form-outgoings>
